import { createFileRoute } from "@tanstack/react-router";
import { CategoriesPage } from "@/components/inventory/CategoriesPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/inventory_/categories")({
  beforeLoad: () => {
    requireAuth();
  },
  component: CategoriesPage,
});
